{
    "SEC-Reports-Quick-Search-Fields": [
      {
        "label": "Report Name", "columnname": "reportName", "placeholder": "Report Name",
        "width": "", "datatype": "String", "isLarge": false
      },
      {
        "label": "Report Status", "columnname": "reportStatus", "placeholder": "Report Status",
        "width": "", "datatype": "String", "isLarge": false
      }
    ],


    "SEC-Reports-Grid-Columns" : [
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "",
            "datatype": "",
            "mappingkey": "",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "isrequired": "false",
            "isFormField": "false", 
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Report Name",
            "db_columnname": "reportName",
            "datatype": "String",
            "mappingkey": "reportName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "isrequired": "true",
            "isFormField": "true", 
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Report Status",
            "db_columnname": "reportStatus",
            "datatype": "String",
            "mappingkey": "reportStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "isrequired": "true",
            "isFormField": "true", 
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Quarter",
            "db_columnname": "reportingQuarter",
            "datatype": "int",
            "mappingkey": "reportingQuarter",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Year",
            "db_columnname": "reportingYear",
            "datatype": "int",
            "mappingkey": "reportingYear",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Start Date",
            "db_columnname": "reportingStartDate",
            "datatype": "Date",
            "mappingkey": "reportingStartDate",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "End Date",
            "db_columnname": "reportingEndDate",
            "datatype": "Date",
            "mappingkey": "reportingEndDate",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Customer",
            "db_columnname": "customer",
            "datatype": "String",
            "mappingkey": "customer",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "isrequired": "true",
            "isFormField": "true", 
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Sender IMID",
            "db_columnname": "senderIMID",
            "datatype": "String",
            "mappingkey": "senderIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "isrequired": "true",
            "isFormField": "true", 
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Generated Date",
            "db_columnname": "generationDate",
            "datatype": "String",
            "mappingkey": "generationDate",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Approved Date",
            "db_columnname": "approvedDate",
            "datatype": "String",
            "mappingkey": "approvedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Declined Date",
            "db_columnname": "declinedDate",
            "datatype": "String",
            "mappingkey": "declinedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Published Date",
            "db_columnname": "publishedDate",
            "datatype": "String",
            "mappingkey": "publishedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Generated By",
            "db_columnname": "generatedBy",
            "datatype": "String",
            "mappingkey": "generatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Approved User",
            "db_columnname": "approvedBy",
            "datatype": "String",
            "mappingkey": "approvedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "Declined User",
            "db_columnname": "declinedBy",
            "datatype": "String",
            "mappingkey": "declinedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Published User",
            "db_columnname": "publishedBy",
            "datatype": "String",
            "mappingkey": "publishedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "s3 Path Published",
            "db_columnname": "s3PathPublished",
            "datatype": "String",
            "mappingkey": "s3PathPublished",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }

    ]   

}